// extracted by mini-css-extract-plugin
export default {"container":"orders_container__QU9hw"};